module.exports = __webpack_public_path__ + "img/login-background.067b9646.png";